import {Clients, removeClient} from './clients.js';
import {getLogger} from '../logger.js';
import {GatewayNode} from '../node.js';

const log = getLogger('gateway.scavenger');

function scavengeClients(clients: Clients, node: GatewayNode, olderThan: number) {
    log.trace(`running client scavenger. collecting everything older than ${olderThan}`);
    clients.forEach((v, key) => {
        if (v.lastAccess <= olderThan) {
            log.info(`scavenging client for ${key}. Last access ${new Date(v.lastAccess)} < ${new Date(olderThan)}`);
            try {
                removeClient(clients, node, key);
                if (v.onScavenge) {
                        v.onScavenge();
                }
            }
            catch (ex) {
                log.warn(`error scavenging client for ${key}`, ex);
            }
        }
    });

}
const MIN_INACTIVE_SECONDS = 10;
const MILLIS_IN_SECOND = 1000;
export default class Scavenger {

    private scavenging: boolean = false;
    private readonly cancel: ReturnType<typeof setTimeout> | undefined;

    constructor(private readonly clients: Clients,
                private readonly node: GatewayNode,
                private readonly inactiveSeconds: number) {
        if (inactiveSeconds > 0) {
            log.info(`clients inactive for ${inactiveSeconds} seconds will be scavenged`);
            this.cancel = setInterval(async () => {
                this.scavengeClients();
            }, MILLIS_IN_SECOND);
        }
    }

    scavengeClients() {
        if (this.scavenging) {
            return;
        }
        try {
            this.scavenging = true;
            const lastAccess = 2 * Math.max(this.inactiveSeconds, MIN_INACTIVE_SECONDS) * MILLIS_IN_SECOND;
            const olderThan = Date.now() - lastAccess;
            scavengeClients(this.clients, this.node, olderThan);

        } finally {
            this.scavenging = false;
        }
    }

    stop() {
        clearTimeout(this.cancel);
    }
}
